(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buggyfix-product-video')) {
    customElements.define('buggyfix-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              this.loadContent();
            } else {
              this.video.pause();
            }
          });
        }, { threshold: 0.25 });

        this.observer.observe(this);
      }

      loadContent() {
        const video = this.video || this.querySelector('video');

        if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        video.muted = true;
        video.play().catch(() => {});
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
